import { Pressable, SxProp, View, Text } from "dripsy";

import React, { useEffect, useState } from "react";

export interface UniRadioGroup {
  [key: string]: any;
}

export interface UniRadioButtonGroupOnValueChangeProps {
  name: string;
  value: any;
}

export interface UniRadioItemProps<T> {
  name: string;
  value?: T;
  buttonValue: T;
  label: string;
}

export interface UniRadioButtonProps<T> extends UniRadioItemProps<T> {
  onValueChange: (value?: T) => void;
}

export const UniRadioButton = <T,>(props: UniRadioButtonProps<T>) => {
  const { value, buttonValue, label, onValueChange } = props;
  const [checked, setChecked] = useState<boolean>(buttonValue === value);

  useEffect(() => {
    setChecked(value === buttonValue);
  }, [value]);

  return (
    <Pressable onPress={() => onValueChange(buttonValue)} sx={styles.container}>
      <View sx={styles.boxOutter}>
        <View sx={checked ? styles.boxChecked : styles.boxUnchecked} />
      </View>
      <Text sx={styles.label}>{label}</Text>
    </Pressable>
  );
};

const styles: Record<string, SxProp> = {
  container: {
    mb: 5,
    flexDirection: "row",
    alignItems: "center",
  },
  boxOutter: {
    width: 20,
    height: 20,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "$borderPrimary",
    borderRadius: 50,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "transparent",
  },
  boxChecked: {
    width: 14,
    height: 14,
    borderRadius: 50,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "$secondary",
  },
  boxUnchecked: {
    width: 18,
    height: 18,
    border: "1px solid transparent",
    borderRadius: 50,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "transparent",
  },
  boxText: {
    color: "$textPrimary",
  },
  label: {
    ml: 8,
    fontSize: 14,
    color: "$textPrimary",
  },
};
